<template>
  <section class="section6">
    <div class="section6-container">
      <!-- Titre principal -->
      <div class="section6-header">
        <h2 class="section-title">Pourquoi Choisir Prymo ?</h2>
        <p class="section-subtitle">
          Nous offrons des solutions technologiques adaptées aux réalités africaines, alliant innovation, accessibilité et performance.
        </p>
      </div>

      <!-- 3 blocs explicatifs -->
      <div class="info-grid">
        <div class="info-card" v-for="(block, index) in blocks" :key="index">
          <h4 class="info-title">{{ block.title }}</h4>
          <p class="info-text">{{ block.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Section6View',
  data() {
    return {
      blocks: [
        {
          title: 'Une Approche Locale & Humaine',
          text: 'Nous comprenons les besoins des utilisateurs africains. Nos solutions sont pensées pour être simples, accessibles, et à fort impact social.'
        },
        {
          title: 'Des Technologies Flexibles',
          text: 'Notre plateforme s\'intègre facilement à tout système existant, s\'adapte à vos besoins métiers et évolue avec votre croissance.'
        },
        {
          title: 'Une Fiabilité à Toute Épreuve',
          text: 'Nous garantissons une infrastructure solide, sécurisée et disponible 24/7, pour soutenir vos opérations critiques.'
        },
        {
          title: 'Couverture Nationale et Régionale',
          text: 'Présents dans les 26 provinces de la RDC et en expansion dans la zone CEMAC, nous connectons les entreprises à travers l\'Afrique centrale.'
        },
        {
          title: 'Solutions de Paiement Globales',
          text: 'Notre intégration de stablecoins permet des règlements internationaux instantanés sans les barrières des devises volatiles ou des frais excessifs.'
        },
        {
          title: 'Conformité et Sécurité Maximale',
          text: 'Agréés par la Banque Centrale du Congo avec un cadre robuste AML/KYC, nous assurons la sécurité de toutes vos transactions.'
        }
      ]
    };
  }
}
</script>

<style scoped>
.section6 {
  padding: 5rem 2rem;
  color: #2c3e50;
  background-color: #f7f9fb;
}

.section6-container {
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
}

.section-title {
  font-weight: 700;
  margin-bottom: 1rem;
  color: #000c7a;
  font-size: 2.5rem;
}

.section-subtitle {
  max-width: 100%;
  margin: 0 auto 3rem;
  color: #666;
  font-size: 1.2rem;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  text-align: left;
  max-width: 1300px;
  margin: 0 auto;
}

.info-card {
  background: #ffffff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  border-bottom: 4px solid #42b983;
}

.info-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
}

.info-title {
  font-weight: 700;
  margin-bottom: 1rem;
  color: #2c3e50;
  font-size: 1.3rem;
}

.info-text {
  color: #444;
  line-height: 1.6;
  font-size: 1rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .section6 {
    padding: 3rem 1rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .section-subtitle {
    font-size: 1rem;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }
}
</style>